import { render, staticRenderFns } from "./BedKey.vue?vue&type=template&id=c244c950"
import script from "./BedKey.vue?vue&type=script&lang=js"
export * from "./BedKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports